/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IDynProductSpecification contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum displayStyle {
    tabs = 'tabs',
    accordion = 'accordion',
    table = 'table'
}

export interface IDynProductSpecificationConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    displayStyle?: displayStyle;
    className?: string;
    clientRender?: boolean;
    tabLabelProductDetails?: string;
    tabLabelIngredients?: string;
    tabLabelInstructions?: string;
    tabLabelNutrition?: string;
    tabLabelOthers?: string;
    specialNeedsElementLabel?: string;
    nutritionalElementLabel?: string;
    nutritionalValueLabel?: string;
}

export interface IDynProductSpecificationResources {
    trueValueText: string;
    falseValueText: string;
    additionalDownloadsText: string;
    wbsSnAdaptedTexture: string;
    wbsSnAntiReflux: string;
    wbsSnCleanLabel: string;
    wbsSnDiabeticFriendly: string;
    wbsSnGlutenFree: string;
    wbsSnHalal: string;
    wbsSnHighCalorie: string;
    wbsSnHighProtein: string;
    wbsSnLactoseFree: string;
    wbsSnLowSalt: string;
    wbsSnMadeFrance: string;
    wbsSnMadeRomania: string;
    wbsSnNoMsgAdded: string;
    wbsSnOrganic: string;
    wbsSnSaltFree: string;
    wbsSnTransit: string;
    wbsSnVeganFriendly: string;
    wbsSnVegetarian: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IDynProductSpecificationProps<T> extends Msdyn365.IModule<T> {
    resources: IDynProductSpecificationResources;
    config: IDynProductSpecificationConfig;
}
